import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useWebBannerImages } from "../../Others.hook";
import { fields } from "../../constants";

export const AddEditWebBannerImages = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editFaq,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditFaq,
  } = useWebBannerImages(query.get("editId") || "");

  const {
    data: FaqById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditFaq();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
    title_en: FaqById
        ? decodeHTML(FaqById.payload.title_en)
        : editFaq
          ? decodeHTML(editFaq?.[0]?.title_en)
          : "",
    title_ms: FaqById ? decodeHTML(FaqById.payload.title_ms) : editFaq ? decodeHTML(editFaq?.[0]?.title_ms) : "",
    title_zh: FaqById
        ? decodeHTML(FaqById.payload.title_zh)
        : editFaq
          ? decodeHTML(editFaq?.[0]?.title_zh)
          : "",
    description_en: FaqById
        ? decodeHTML(FaqById.payload.description_en?.value)
        : editFaq
          ? decodeHTML(editFaq?.[0]?.description_en)
          : "",
    description_ms: FaqById ? decodeHTML(FaqById.payload.description_ms?.value) : editFaq ? decodeHTML(editFaq?.[0]?.description_ms) : "",
    description_zh: FaqById
        ? decodeHTML(FaqById.payload.description_zh?.value)
        : editFaq
          ? decodeHTML(editFaq?.[0]?.description_zh)
          : "",
    image: FaqById ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: FaqById?.payload?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: editFaq?.[0]?.image
            },
          ]),
    },
    fields: fields.webBannerImages,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let descKeys: any = [
        "description_zh",
        "description_ms",
        "description_en",
      ];
      for (const key of descKeys) {
        try {
          data[key] = {
            value: data[key] || "",
            format: "full_html",
          };
        } catch (error) {}
      }

    const payload = {
      action: action,
      method: method,
      module: "OTHERS",
      subModule: `banners_webBannerImages`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        nid: editFaq?.[0]?.nid || FaqById?.payload?.nid,
        published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingFaq}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Web Banner Image`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${magpHost}/api/banners-images-for-all-nodes-crud-api/${editFaq?.[0]?.nid || FaqById?.payload?.nid}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
